<!-- 最新报道 -->
<template>
<div class="last-post-item">
    <div class="cont">
        <div class="title"><a :href="url|hostBuild('news')" target="_blank" :title="post.title">{{post.title}}</a></div>
        <div class="subf-cont">
            <div>{{post.property.topic[0].name}}</div>
            <div>{{post.property.publishTime|timeToStr}}</div>
        </div>
    </div>
    <div class="cove-img">
        <YorkbbsImage aspect class="cover" :src="post.imageList[0]" target="_blank"   borderRadius="4px" :href="url|hostBuild('news')"></YorkbbsImage>
    </div>
</div>
</template>
<script>
export default {
    name:'LastNewsItem',
    props:['post'],
    data(){
        return {

        }
    },
    computed:{
        url(){
            return `/detail/${this.post.property.topic[0].name}/${this.post.id}`
        }
    }
}
</script>
<style lang="less" scoped>
.last-post-item{
    padding: 0 0 15px 0; display: flex; align-items: stretch;
    .cove-img{ margin-left: 15px; width: 100px;}
    .cont{
        flex:1; display: flex; flex-direction: column;justify-content:space-between;
        .subf-cont{
            display: flex; align-items: center; font-size: 14px; line-height: 20px;  color: #999;
            div{margin-right: 10px;}
        }
        .title{
            max-height: 48px; overflow: hidden;
            a{
                font-size: 16px; line-height: 24px; color: #111; font-weight: 400; 
                &:hover{color: #e43a3a;}
            }
        }
    }
}
@media screen and (min-width:768px){
    .last-post-item{
        .cove-img{width: 160px;}
        .cont{
           
            .title{
                 max-height: 60px;
                a{font-size: 18px; line-height: 30px;}
            }
        }
    }

}
</style>